import { doc } from 'firebase/firestore'
import { useMemo } from 'react'
import { useDocument } from 'react-firebase-hooks/firestore'
import { db } from '../../../data/firebase'

/**
 * @typedef {Object} UseAuctionProductReturn
 * @property {boolean} loading
 * @property {PublicProduct} product
 *
 * get auction products
 * @param {string} auctionId
 * @param {string} productId
 * @returns {UseAuctionProductReturn} auction products
 */
export const useAuctionProduct = (auctionId, productId) => {
  const [product, loading] = useDocument(
    (auctionId && productId && doc(db, `auctions/${auctionId}/products`, productId)) || undefined
  )
  const productData = useMemo(() => {
    if (!product?.exists()) return {}

    return { id: product.id, ...product.data() }
  }, [product])

  return { product: productData, loading }
}
